import styled from 'styled-components'
import theme from 'theme_'

import { StyledMySubscriptionWrapper } from 'components/MySubscription/styles'

export const SubscriptionsSummaryWrapper = styled(StyledMySubscriptionWrapper)`
  margin-top: ${theme.spacing.md};
`
